import { connect } from "react-redux";
import CreateTicket from "./createTicket";
import { bindActionCreators } from "redux";
import { createTicket, getSearchUser } from "services/redux/tickets/createTicket/action";
import { documentUploadUrl } from "services/redux/fileUpload/action";

const mapStateToProps = (state) => ({
    documentUrlData: state.fileUploadReducer.documentUrlData,
    createTicketRes : state.createTicketReducer.createTicketRes,
    searchUser: state.createTicketReducer.searchUser,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators({
        createTicket,
        documentUploadUrl,
        getSearchUser,
    }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(CreateTicket);
